import Plyr from 'plyr';
import 'featherlight';
import 'devbridge-autocomplete';
import 'featherlight/src/featherlight.gallery';
import Cookies from 'js-cookie/src/js.cookie';
import toastr from 'toastr';


import {stage_slider, stage_v2_slider} from '../components/slick-carousel';
import {product_slider} from '../components/slick-carousel';
import {pharmacy_search_component, set_last_seen_product_cookie, set_last_seen_promotion_cookie, remove_last_seen_product_cookie_global, remove_last_seen_promotion_cookie_global} from '../components/pharmacy-search-component';
import {back_to_top} from '../components/back-to-top';
import {pharmacy_search_autocomplete} from '../components/pharmacy-search-autocomplete';
import {pharmacist_tip} from '../components/pharmacist_tip';
import {sticky_elements} from '../components/sticky';
import {ie11} from '../components/ie11';
import {thirdparty} from '../components/thirdparty';
import {anchor_scrolling} from '../components/anchor_scrolling';

export default {
  init() {
    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight()

    $(document).on('mousedown', '.autocomplete-suggestion', e => {
      $(e.target).click();
    });

    toastr.options = {
      'closeButton': true,
      'newestOnTop': true,
      'progressBar': false,
      'positionClass': 'toast-bottom-right',
      'preventDuplicates': true,
      'onclick': null,
      'showDuration': '300',
      'showEasing': 'swing',
      'hideEasing': 'linear',
      'showMethod': 'fadeIn',
      'hideMethod': 'fadeOut',
      'timeOut': '0',
      'extendedTimeOut': '0',
    }

    // let prevScrollpos = window.pageYOffset;

    if (!thirdparty()) {
      $('.cookie-agreement-required').removeClass('d-none');
    }

    $('.mea-accept-thirdparty').click(function(e){
      e.preventDefault();
      Cookies.set('mea-cb-required', 'true', { expires: 365, path: '/' })
      Cookies.set('mea-cb-thirdparty', 'true', { expires: 365, path: '/' })
      window.location.reload();
    });

    $('.mea-accept-thirdparty-once').click(function(e){
      e.preventDefault();
      window.location.hash = 'accept-thirdparty';
      window.location.reload();
    });

    var toggled = false;

    $('.navbar-toggler').click(function (e) {
      e.preventDefault();
      if ($('body').hasClass('show-navigation')) {
        $(this).parents('.navbar').find('.navbar-collapse').removeClass('is-active');
        $(this).find('.hamburger').removeClass('is-active');
        $('#overlay').fadeOut(500);
        $('body').removeClass('show-navigation');
      } else {
        $(this).parents('.navbar').find('.navbar-collapse').addClass('is-active');
        $(this).find('.hamburger').addClass('is-active');
        $('#overlay').fadeIn(500);
        $('body').addClass('show-navigation');
        toggled = true;
      }
    });

    $( window ).resize(function() {
      if($(window).width() > 991 && toggled === true) {
        $('.navbar').find('.navbar-collapse').removeClass('is-active');
        $('.navbar-toggler').find('.hamburger').removeClass('is-active');
        $('#overlay').fadeOut(500);
        $('body').removeClass('show-navigation');
        toggled = false;
      }
    });

    // Import Plyr
    $('.video-player').each(function () {
      var videoType = $(this).data('mea-video-type');
      var url = $(this).data('mea-video-url');

      if (thirdparty()) {
        if(videoType == 'intern'){
          $(this).html('<video playsinline controls><source src="' + url + '" type="video/mp4" /></video>');
          new Plyr($(this).find('video'), {
            iconUrl: '/app/themes/mea/dist/images/plyr.svg',
          });
        } else {
          $(this).addClass('plyr__video-embed');
          $(this).html('<iframe src="' + url + '" allowfullscreen allowtransparency allow="autoplay"></iframe>');
          new Plyr(this, {
            iconUrl: '/app/themes/mea/dist/images/plyr.svg',
            youtube: {
              noCookie: true,
              rel: 0,
              showinfo: 0,
            },
          });
        }
      } else if(videoType == 'intern'){
        $(this).html('<video playsinline controls><source src="' + url + '" type="video/mp4" /></video>');
        new Plyr($(this).find('video'), {
          iconUrl: '/app/themes/mea/dist/images/plyr.svg',
        });
      }
    });

    $('.trigger-click').click(function(e){
      e.preventDefault();
      $($(this).attr('href')).click();

      if($(this).data('scrollto')){
        let target = $(this).data('scrollto');
        if ($(target).length > 0) {

          let searchHeader = 0;
          if($('#pharmacy-search-header').length > 0){
            searchHeader = $('#pharmacy-search-header').outerHeight();
          }
          $([document.documentElement, document.body]).animate({
            scrollTop: $(target).offset().top - $('header').outerHeight() - searchHeader - 15,
          }, 1000);
        }
      }
    });

    // Consent Functional Cookies
    $('script[data-cookie-consent]').each(function () {
      let consent = $(this).data('cookie-consent').split('|');
      let code = $(this).html();

      $.each(consent, function (index, val) {
        // @todo
        if (typeof Cookies.get('mea-cb-' + val) != 'undefined' && String(Cookies.get('mea-cb-' + val)) == 'true') {
          eval(code);
          return false;
        }
      });
    });

    // Pharmacy Search
    $('form.form-pharmacy-search-redirect').on('submit', function (e) {
      e.preventDefault();

      let query = $(this).find('input[name="pharmacy-search-query"]').val();
      let url = mea.pharmacy_search;

      url += encodeURIComponent(query) + '/';

      if (typeof $(this).data('filter') !== 'undefined') {
        let filter = $(this).data('filter').split('|');

        $.each(filter, function (index, key) {
          $.each(mea.pharmacy_search_filter, function (indexFilter, element) {
            if (element.key == key) {
              url += encodeURI(element.url) + '/';
              return false;
            }
          });
        });
      }

      set_last_seen_product_cookie($(this));
      set_last_seen_promotion_cookie($(this));

      window.location.href = url
    });


    if (!navigator.geolocation) {
      $('.get-location').hide();
    }

    $('.get-location').click(function (e) {
      e.preventDefault();
      var $this = $(this);
      if (navigator.geolocation) {
        if ($this.find('.location').length > 0) {
          $this.find('.location').addClass('d-none');
        }

        if ($this.find('.loader').length > 0) {
          $this.find('.loader').removeClass('d-none');
        }

        let filterURL = '';
        if ($this.parents('form').length > 0) {
          let $form = $this.parents('form');
          set_last_seen_product_cookie($form);

          if (typeof $form.data('filter') !== 'undefined') {
            let filter = $form.data('filter').split('|');
            $.each(filter, function (index, key) {
              $.each(mea.pharmacy_search_filter, function (indexFilter, element) {
                if (element.key == key) {
                  filterURL += encodeURI(element.url) + '/';
                  return false;
                }
              });
            });
          }
        }
        navigator.geolocation.getCurrentPosition(function (position) {
          window.location.href = mea.pharmacy_search + encodeURI(position.coords.latitude + ',' + position.coords.longitude) + '/' + filterURL;
        }, function error() {
          toastr.warning('Diese Webseite verfügt nicht über die Berechtigung zur Verwendung der Geolocation-API.', 'Es ist ein Fehler aufgetreten');

          if ($this.find('.location').length > 0) {
            $this.find('.location').removeClass('d-none');
          }

          if ($this.find('.loader').length > 0) {
            $this.find('.loader').addClass('d-none');
          }
        }, {
          enableHighAccuracy: false,
          timeout: 5000,
        });
      }
    });

    $('.submit-form').click(function (e) {
      e.preventDefault();
      $(this).parents('form').submit();
    });

    $('a[href="#cookies-verwalten"]').click(function (e) {
      e.preventDefault();
      window.meaCookiebanner.showPreferencesDialog();
    });

    $('.jumper').click(function (e) {
      e.preventDefault();
      let target = $(this).attr('href');
      if ($(target).length > 0) {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(target).offset().top - $('header').outerHeight() - 15,
        }, 1000);
      }
    });

    stage_slider();
    stage_v2_slider();
    product_slider();
    back_to_top();
    pharmacy_search_autocomplete();
    pharmacy_search_component();
    remove_last_seen_product_cookie_global();
    remove_last_seen_promotion_cookie_global();
    pharmacist_tip();
    anchor_scrolling();
    sticky_elements();
  },

  finalize() {
    ie11();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js